import React from 'react'
import { HomeRails } from '../home-rails'
import { HomeContentCard } from '../home-content-card'
import { HOME_SECTION_TYPE } from './home-sections'

export const RelatedLastReadRails = ({ relatedLastReadSection }) => {
  const { items } = relatedLastReadSection

  return (
    <HomeRails
      title='Related to what you Last Read'
      items={items}
      dataTest='home-related-last-read-rails'
      renderItem={(item, itemIndex) => {
        return (
          <HomeContentCard
            content={item}
            dataTest={`related-last-read-${itemIndex}`}
            itemIndex={itemIndex}
            railType={HOME_SECTION_TYPE.RELATED_LAST_READ}
          />
        )
      }}
    />
  )
}
